
function convertPhoneNumber(phoneNumber) {
  try {
    if (!phoneNumber || (phoneNumber.includes('+') && phoneNumber.split(' ').length === 5)) {
      // already formatted or not existing
      return phoneNumber;
    }

    if (typeof phoneNumber === 'number') phoneNumber = String(phoneNumber);

    let digits = phoneNumber.replace(/\D/g, '');

    // Ensure starts with 7 (Russia country code)
    if (digits.startsWith('8')) digits = '7' + digits.slice(1);
    if (!digits.startsWith('7')) digits = '7' + digits;

    // Format as +7 XXX XXX XX XX
    return digits.replace(
      /^7(\d{3})(\d{3})(\d{2})(\d{2})$/,
      '+7 $1 $2 $3 $4',
    );
  } catch (e) {
    return phoneNumber;
  }
}

export default convertPhoneNumber;
